import Button from "components/button";
import EmptyState from "components/EmptyState/EmptyState";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";
import Modalheader from "components/modal/components/header";
import useModal from "components/modal/useModal";
import UseContext from "hooks/useContext";
import Yousign from "hooks/yousign";
import ApiDatabase from "server";

// YouSign sandbox links carry sandbox=true; disable_domain_validation only works there
const isSandboxLink = (link) => {
  try {
    return new URL(link).searchParams.get("sandbox") === "true";
  } catch {
    return false;
  }
};

const ModalSignature = () => {
  const { refreshLoadUser } = UseContext();
  const { toggle } = useModal();
  const { dataYousign, signatureLink } = UseContext();

  const isSandbox = isSandboxLink(signatureLink);
  const iframeSrc = isSandbox
    ? `${signatureLink}&disable_domain_validation=true`
    : signatureLink;

  const yousignInit = () => {
    const yousign = new Yousign({
      signatureLink: signatureLink,
      iframeContainerId: "iframe-container",
      isSandbox,
    });

    yousign.onSuccess((data) => {
      console.log("Signer has successfully signed");
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    toggle();
    ApiDatabase.putStatusContract(
      { contract: dataYousign },
      (data) => {
        if (data.success) {
          window.location.reload(false);
          toggle();
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };

  return (
    <>
      <Modalheader hide={handleSubmit} hideShow={true}>
        Signature du document
      </Modalheader>
      <ModalBody>
        {signatureLink ? (
          <iframe
            id={"iframe-container"}
            className={"w-full h-[700px]"}
            src={iframeSrc}
            onLoad={yousignInit}
          ></iframe>
        ) : (
          <EmptyState type={"signature_loading"} />
        )}
      </ModalBody>
      <ModalFooter>
        <Button size={"LG"} color={"SECONDARY"} onClick={handleSubmit}>
          Fermer
        </Button>
      </ModalFooter>
    </>
  );
};

export default ModalSignature;
